/* Stykhia sections: FAQ accordion animation and reveal on scroll.
   No libraries. Scrolling and opening both work without this file. */
(function () {
  if (window.smSectionsLoaded) return;
  window.smSectionsLoaded = true;

  function animate(item, content, from, to, done) {
    item.dataset.animating = 'true';
    content.style.overflow = 'hidden';
    var animation = content.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: 250, easing: 'ease' }
    );
    animation.onfinish = function () {
      content.style.overflow = '';
      delete item.dataset.animating;
      if (done) done();
    };
  }

  function initAccordion(root) {
    if (root.dataset.smReady) return;
    root.dataset.smReady = 'true';
    if (!root.animate) return;

    root.querySelectorAll('details').forEach(function (item) {
      var summary = item.querySelector('summary');
      var content = item.querySelector('[data-sm-answer]');
      if (!summary || !content) return;

      summary.addEventListener('click', function (event) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.preventDefault();
        if (item.dataset.animating) return;

        if (item.open) {
          animate(item, content, content.offsetHeight, 0, function () { item.open = false; });
        } else {
          item.open = true;
          animate(item, content, 0, content.scrollHeight);
        }
      });
    });
  }


  /* Reveal on scroll. One IntersectionObserver for the page: an element shows once 15% of it is
     in the viewport (bottom edge pulled in by 8%) and never hides again. Elements of a
     [data-sm-reveal-group] that appear together come in one after another. The hidden state is
     CSS and only exists while html[data-sm-motion] is set, so without JS everything is visible. */
  var revealObserver = null;
  var REVEAL_STEP = 90;
  var REVEAL_MAX_STEPS = 6;

  function showReveal(el, delay, instant) {
    if (instant) el.classList.add('is-instant');
    el.style.setProperty('--sm-delay', delay + 'ms');
    el.classList.add('is-revealed');
    window.setTimeout(function () {
      el.classList.add('is-done');
      el.style.removeProperty('--sm-delay');
    }, instant ? 0 : delay + 1600);
  }

  function onReveal(entries) {
    var groups = new Map();
    entries.forEach(function (entry) {
      var el = entry.target;
      var tall = el.offsetHeight * 0.15 > window.innerHeight * 0.84;
      if (!entry.isIntersecting || (entry.intersectionRatio < 0.15 && !tall)) return;
      revealObserver.unobserve(el);
      var group = el.closest('[data-sm-reveal-group]');
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(el);
    });

    groups.forEach(function (items, group) {
      items.sort(function (a, b) {
        return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
      var step = group ? parseInt(group.getAttribute('data-sm-reveal-step'), 10) || REVEAL_STEP : 0;
      items.forEach(function (el, index) {
        showReveal(el, Math.min(index, REVEAL_MAX_STEPS) * step, false);
      });
    });
  }

  function outsideTrack(el, track) {
    var box = track.getBoundingClientRect();
    var rect = el.getBoundingClientRect();
    return rect.left >= box.right - 1 || rect.right <= box.left + 1;
  }

  function initReveal() {
    var root = document.documentElement;
    if (!root.hasAttribute('data-sm-motion')) return;
    if (!('IntersectionObserver' in window)) {
      root.removeAttribute('data-sm-motion');
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(onReveal, { threshold: [0, 0.15], rootMargin: '0px 0px -8% 0px' });
    }
    document.querySelectorAll('[data-sm-reveal]:not([data-sm-seen])').forEach(function (el) {
      el.setAttribute('data-sm-seen', '');
      var track = el.closest('[data-sm-track]');
      if (track && outsideTrack(el, track)) {
        showReveal(el, 0, true);
        return;
      }
      revealObserver.observe(el);
    });
  }

  function run() {
    document.querySelectorAll('[data-sm-accordion]').forEach(initAccordion);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
